import {UIComponent} from "@/engine/UI/UIComponent.js";
import {RasterLayer} from "@/engine/layers/rasterLayer.js";

export class UICDownloadSourceFile extends UIComponent {
    constructor(options, view = 'url-to-share') {
        super(options, view);
        this.id = 'sourceFileExport'
        this.title = 'Download source file'
        this.mainActionName = 'DOWNLOAD'
        this.cancelActionName = 'CANCEL'
        this.className = ''
    }

    validateBeforeOpen() {
        return ! (this._downloadUrl() === "")
    }

    open(container, parent, data) {
        super.open(container, parent, {
            value: this._downloadUrl(),
            description: 'An original GeoTiff file can be downloaded by this link',
            onclick: ''
        })
    }

    onMainAction() {
        this.downloadLink = document.createElement("a")
        Object.assign(this.downloadLink.style, {"display": "none"});
        Object.assign(this.downloadLink, {"download": this._fileName()});
        this.downloadLink.href = this._downloadUrl()
        this.downloadLink.click()
        return true
    }

    _downloadUrl() {
        // only one raster layer is supported now
        if (! this.layer || ! this.layer instanceof RasterLayer)
            return ""

        if (! this.layer.file || this.layer.file === "")
            return ""

        return new URL(window.location).origin + '/d/s/' + this.layer.file + '/' + this._fileName()
    }

    _fileName() {
        // todo map.tif replace with normal name from area.name, but don't forget to replace some chars
        return 'map.tif'
    }

    onCancelAction() {
        return true
    }

}
